import SortArrows from '@rio-cloud/rio-uikit/SortArrows';
import { SortDirection } from '../../models';
import { ReactNode } from 'react';
import classNames from 'classnames';

export type HeaderCellSorting<T> = {
  sortBy?: keyof T;
  sortDirection: SortDirection;
  onSortClick: (sortDirection: SortDirection) => void;
};

type SortableTableHeaderCellProps<T> = {
  id: keyof T;
  label: ReactNode;
  sorting?: HeaderCellSorting<T>;
};

export const TableHeaderCell = <T extends object>({
  id,
  label,
  sorting,
}: SortableTableHeaderCellProps<T>) => {
  const handleSortChange = () => {
    if (sorting) {
      const direction = nextSortDirection();
      sorting.onSortClick(direction);
    }
  };

  const nextSortDirection = (): SortDirection => {
    if (id === sorting?.sortBy) {
      return sorting.sortDirection === SortDirection.ASCENDING
        ? SortDirection.DESCENDING
        : SortDirection.ASCENDING;
    }
    return SortDirection.ASCENDING;
  };

  const getSortIcon = () => {
    if (!sorting) {
      return <></>;
    }

    return sorting.sortBy === id ? (
      <SortArrows direction={sorting.sortDirection} />
    ) : (
      <SortArrows />
    );
  };

  return (
    <th
      className={classNames('user-select-none', {
        'sort-column': sorting,
      })}
      onClick={handleSortChange}
      data-field={id}
      data-sortby={id}
    >
      {sorting ? (
        <span className="display-flex align-items-center">
          <span>{getSortIcon()}</span>
          <span className="ellipsis-1">{label}</span>
        </span>
      ) : (
        <span className="ellipsis-1">{label}</span>
      )}
    </th>
  );
};
